export default class PageScroll {
    constructor() {
        this.scrollPage = [...document.querySelectorAll(`a.jsPageScroll`)];

        this.events();
    }

    events() {
        if (this.scrollPage.length) {
            this.scrollPage.forEach((link) =>
                link.addEventListener("click", this.handleScrollPage.bind(this))
            );
        }
    }

    handleScrollPage(e) {
        e.preventDefault();
        const searchSection = document.querySelector(`${e.currentTarget.hash}`);

        if (!searchSection) return;

        const searchSectionPosition = searchSection.getBoundingClientRect().top;

        window.scrollBy({
            top: searchSectionPosition - 30,
            behavior: "smooth",
        });
    }
}
